import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {SetupGuideTask, SetupGuideTaskProps} from '../common/setupGuideTask';

/*
 * Constants.
 */

const helpCenterUrl = 'https://help.front.com/t/h7h1h2s/customer-beta-understanding-front-accounts';

/*
 * Props.
 */

type DiscoverFrontAccountsTaskProps = Omit<SetupGuideTaskProps, 'label' | 'onClick'>;

/*
 * Component.
 */

export const DiscoverFrontAccountsTask: FC<DiscoverFrontAccountsTaskProps> = ({isComplete}) => (
  <SetupGuideTask
    label={<Trans id="accounts-setup-guide-task-discover-front-accounts">Discover Front Accounts</Trans>}
    isComplete={isComplete}
    onClick={() => openInBrowser(helpCenterUrl)}
  />
);
